

export default[
    {
        title:'PROMOTION OF DEFENCE AMONG YOUTH',
        image:"images/home14.jpeg",
    },
    {
        title:'PROMOTION OF SPORTS',
        image:"images/home15.jpeg",
    },
    {
        title:'PROMOTION OF SCIENTIST COMMUNITY/TECHNOLOGY',
        image:"images/home16.jpeg",
    },  {
        title:'PROMOTION OF DEFENCE AMONG YOUTH',
        image:"images/home14.jpeg",
    },
    {
        title:'PROMOTION OF SPORTS',
        image:"images/home15.jpeg",
    },
    {
        title:'PROMOTION OF SCIENTIST COMMUNITY/TECHNOLOGY',
        image:"images/home16.jpeg",
    }
    
    
   
]